module.exports = __webpack_public_path__ + "static/media/BillClosed.dc78e0f1.svg";